
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`«Klar, das Problem Fliegen und Klimaerwärmung ist mir bewusst. Ich arbeite in der Reisebranche, und wir weisen alle Kunden darauf hin, dass sie das CO2 kompensieren können. Ich habe den Flug schon vor längerer Zeit über das Internet gebucht, dabei aber offen gestanden an die Kompensation nicht gedacht. Die Reise gehört zu meinem Weiterbildungsstudium, die muss ich machen.»`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;